import * as yup from "yup";

export const capitalizationFormSchema = yup.object().shape({
    realEstateId: yup.string(),
    insuranceCompany: yup.string().required("Seguradora é obrigatória"),
    status: yup.string().required("Status é obrigatório"),

    ownerDocument: yup.string().required("Documento do proprietário é obrigatório"),
    ownerName: yup.string().required("Nome do proprietário é obrigatório"),
    ownerEmail: yup.string().email("Email inválido").required("Email do proprietário é obrigatório"),
    ownerPhone: yup.string().required("Telefone do proprietário é obrigatório"),

    rentAmount: yup.string().required("Valor do aluguel é obrigatório"),
    condominiumAmount: yup.string(),
    waterAmount: yup.string(),
    energyAmount: yup.string(),
    gasAmount: yup.string(),
    iptuAmount: yup.string(),
    startDate: yup.string().required("Início da vigência é obrigatório"),
    endDate: yup.string().required("Fim da vigência é obrigatório"),
    plan: yup.string().required("Plano é obrigatório"),
    multiplier: yup.string().required("Multiplicador é obrigatório"),
    titleAmount: yup.string().required("Valor do título é obrigatório"),

    titleNumber: yup.string(),
    proposalNumber: yup.string(),
    issueDate: yup.string(),

    propertyZipcode: yup.string().required("CEP é obrigatório"),
    propertyStreet: yup.string().required("Logradouro é obrigatório"),
    propertyNumber: yup.string().required("Número é obrigatório"),
    propertyComplement: yup.string(),
    propertyDistrict: yup.string().required("Bairro é obrigatório"),
    propertyCity: yup.string().required("Cidade é obrigatória"),
    propertyState: yup.string().required("UF é obrigatória"),
    propertyType: yup.string().required("Tipo de imóvel é obrigatório"),
    propertyRentalType: yup.string().required("Tipo de locação é obrigatório"),

    tenantDocument: yup.string().required("CPF/CNPJ do locatário é obrigatório"),
    tenantName: yup.string().required("Nome do locatário é obrigatório"),
    tenantGender: yup.string().required("Gênero é obrigatório"),
    tenantBirthDate: yup.string().required("Data de nascimento é obrigatória"),
    tenantEmail: yup.string().email("Email inválido").required("Email do locatário é obrigatório"),
    tenantPhone: yup.string().required("Telefone do locatário é obrigatório"),
    tenantMaritalStatus: yup.string().required("Estado civil é obrigatório"),
    tenantNationality: yup.string(),
    tenantIdentity: yup.string().required("Identidade é obrigatória"),
    tenantIssuer: yup.string().required("Órgão emissor é obrigatório"),
    tenantState: yup.string().required("UF é obrigatória"),
    tenantIssueDate: yup.string().required("Data de emissão é obrigatória"),
    tenantProfession: yup.string().required("Profissão é obrigatória"),
    tenantMonthlyIncome: yup.string().required("Renda mensal é obrigatória"),
    tenantPpe: yup.boolean(),
});
